interface Connection {
	effectiveType: string;
}

/**
 * Нету поддержки в Safari
 */
export const getConnectionType = () => {
	if ('connection' in navigator) {
		const connection = navigator.connection as Connection;

		return connection.effectiveType;
	}

	return 'unknown';
};
